import Vue from 'vue'
import VueRouter from 'vue-router'
const routes = [
    {
        path: '/',
        component: () => import("../layouts/BasicLayout"),
        name: '首页',
        redirect: "/home",
        children: [
            {
                path: '/home',
                name: 'home',
                meta: { title: '首页', ishome: true, keepAlive: true},
                component: () => import('@/views/home/index')
            },
            {
                path: '/fpthome',
                name: 'fpthome',
                meta: { title: '首页', ishome: true, keepAlive: true },
                component: () => import('@/views/home/indexbydeptId')
            },
            {
                path: '/detail',
                name: 'detail',
                meta: { title: '详情' },
                component: () => import('@/views/home/detail')
            },
            {
                path: '/list',
                name: 'list',
                meta: { title: '列表' },
                component: () => import('@/views/home/list')
            },
            {
                path: '/biddinglist',
                name: 'biddinglist',
                meta: { title: '竞价大厅' },
                component: () => import('@/views/home/biddinglist')
            }
        ]
    },

]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes,
})
export default router